(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { useEffect } from "react";
import useQueryParams from "../../../../hooks/useQueryParams";

const useSetActiveChapter = code2 => {
  const [queryParams, setQueryParams] = useQueryParams();
  const {
    chapter
  } = queryParams;
  useEffect(() => {
    if (code2 && !chapter) {
      setQueryParams({
        chapter: code2
      });
    }
  }, [code2, chapter, setQueryParams]);
};

__signature__(useSetActiveChapter, "useQueryParams{[queryParams, setQueryParams]}\nuseEffect{}", () => [useQueryParams]);

const _default = useSetActiveChapter;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useSetActiveChapter, "useSetActiveChapter", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/hooks/useSetActiveChapter.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/hooks/useSetActiveChapter.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();